export default __webpack_public_path__ + "static/media/color.c448eaa5.svg";